// import { NavLink, useLocation } from "react-router-dom";
// import { sidebarNav } from "../../data/sidebarNav";
// import { useSelector } from "react-redux";
// import { useState } from "react";
// import companyLogo from "../../assets/company logo.jpeg";
// import ZentelexLogo from "../../assets/zentelex-logo.png"
// export default function Sidebar() {

//   const isOpen = useSelector((state) => state.sidebar.isOpen);

//   const [openMenu, setOpenMenu] = useState(null);

//   const location = useLocation();

//   // GET USER FROM LOCAL STORAGE
//   const user = JSON.parse(localStorage.getItem("user"));

//   // console.log("user:", user);

//   // USER ROLE
//   const userRole = user?.role || "";

//   // FILTER MENUS BASED ON ROLE
//   const filteredSidebar = sidebarNav.filter((item) =>
//     item.roles?.includes(userRole)
//   );

//   return (
//     <aside
//       className={`bg-[#0f172a] flex flex-col flex-shrink-0 h-full transition-all duration-300 ${isOpen ? "w-52" : "w-16"
//         }`}
//     >

//       {/* LOGO */}
//       {/* LOGO */}
//     {/* LOGO */}
// <div className="border-b border-slate-700 py-4 flex justify-center">

//   {isOpen ? (

//     <div className="flex items-center gap-3">

//       {/* Logo */}
//       <div className="bg-white rounded-xl p-2 shadow-md">

//         <img
//           src={companyLogo}
//           alt="Company Logo"
//           className="w-12 h-12 object-contain"
//         />

//       </div>

//       {/* Text */}
//       <div>

//         <h1 className="text-white text-lg font-bold leading-none">
//           R&A
//         </h1>

//         <p className="text-slate-400 text-xs mt-1">
//           Technologies Services Pvt Ltd
//         </p>

//       </div>

//     </div>

//   ) : (

//     <div className="bg-white rounded-lg p-1 shadow-sm">

//       <img
//         src={companyLogo}
//         alt="Company Logo"
//         className="w-9 h-9 object-contain"
//       />

//     </div>

//   )}

// </div>

//       {/* NAVIGATION */}
//       <nav className="flex-1 py-3 overflow-y-auto">

//         {filteredSidebar.map((item, index) => {

//           const isParentActive =
//             item.children &&
//             item.children.some((sub) =>
//               location.pathname.startsWith(sub.path)
//             );

//           return (
//             <div key={index}>

//               {/* PARENT MENU */}
//               {item.children ? (
//                 <button
//                   onClick={() =>
//                     setOpenMenu(
//                       openMenu === index ? null : index
//                     )
//                   }
//                   className={`flex items-center justify-between w-full py-2.5 text-sm ${isOpen ? "px-5" : "justify-center"
//                     } ${isParentActive
//                       ? "bg-blue-600 text-white"
//                       : "text-slate-300 hover:bg-slate-700"
//                     }`}
//                 >

//                   <div className="flex items-center gap-3">
//                     {item.icon}

//                     {isOpen && (
//                       <span>{item.label}</span>
//                     )}
//                   </div>

//                 </button>

//               ) : (

//                 <NavLink
//                   to={item.path}
//                   className={({ isActive }) =>
//                     `flex items-center ${isOpen
//                       ? "gap-3 px-5"
//                       : "justify-center"
//                     } py-2.5 text-sm ${isActive
//                       ? "bg-blue-600 text-white font-semibold"
//                       : "text-slate-300 hover:bg-slate-700"
//                     }`
//                   }
//                 >
//                   {item.icon}

//                   {isOpen && (
//                     <span>{item.label}</span>
//                   )}
//                 </NavLink>

//               )}

//               {/* DROPDOWN */}
//               {item.children &&
//                 openMenu === index &&
//                 isOpen && (

//                   <div className="px-5 py-2">

//                     <select
//                       onChange={(e) => {

//                         if (e.target.value) {

//                           window.location.href =
//                             e.target.value;
//                         }
//                       }}
//                       className="w-full h-7 px-1 text-xs bg-white border border-slate-400 text-black rounded-sm focus:outline-none cursor-pointer"
//                       defaultValue=""
//                     >

//                       <option value="">
//                         Select {item.label}
//                       </option>

//                       {item.children.map((sub, i) => (

//                         <option
//                           key={i}
//                           value={sub.path}
//                         >
//                           {sub.label}
//                         </option>

//                       ))}

//                     </select>

//                   </div>

//                 )}

//             </div>
//           );
//         })}

//       </nav>

//       {/* FOOTER */}
//       <div className="px-5 py-4 border-t border-slate-700 text-xs text-slate-500">
//   {isOpen && (
//     <div className="flex items-center gap-2">
//       <img
//         src={ZentelexLogo}
//         alt="Zentelex Logo"
//         className="w-12 h-12 object-contain"
//       />
//       <span>Design and Developed by Zentelex Pvt Ltd</span>
//     </div>
//   )}
// </div>

//     </aside>
//   );
// }



import { NavLink, useLocation } from "react-router-dom";
import { sidebarNav } from "../../data/sidebarNav";
import { useSelector } from "react-redux";
import { useState } from "react";
import companyLogo from "../../assets/company logo.jpeg";
import ZentelexLogo from "../../assets/zentelex-logo.png";
import useSidebarCounts from "../../hooks/useSidebarCounts";

export default function Sidebar() {

  const isOpen    = useSelector((state) => state.sidebar.isOpen);
  const [openMenu, setOpenMenu] = useState(null);
  const location  = useLocation();

  const user     = JSON.parse(localStorage.getItem("user"));
  const userRole = user?.role || "";

  // ── COUNTS ─────────────────────────────────────────────
  const { counts } = useSidebarCounts();

  const filteredSidebar = sidebarNav.filter((item) =>
    item.roles?.includes(userRole)
  );

  // ── COUNT BADGE ────────────────────────────────────────
  const CountBadge = ({ countKey }) => {
    if (!countKey || !counts[countKey] || counts[countKey] === 0) return null;
    return (
      <span className="ml-auto inline-flex items-center justify-center
        min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold
        bg-red-500 text-white leading-none">
        {counts[countKey] }
      </span>
    );
  };

  return (
    <aside
      className={`bg-[#0f172a] flex flex-col flex-shrink-0 h-full transition-all duration-300 ${
        isOpen ? "w-52" : "w-16"
      }`}
    >

      {/* LOGO */}
      <div className="border-b border-slate-700 py-4 flex justify-center">
        {isOpen ? (
          <div className="flex items-center gap-3">
            <div className="bg-white rounded-xl p-2 shadow-md">
              <img src={companyLogo} alt="Company Logo" className="w-12 h-12 object-contain" />
            </div>
            <div>
              <h1 className="text-white text-lg font-bold leading-none">R&A</h1>
              <p className="text-slate-400 text-xs mt-1">Technologies Services Pvt Ltd</p>
            </div>
          </div>
        ) : (
          <div className="bg-white rounded-lg p-1 shadow-sm">
            <img src={companyLogo} alt="Company Logo" className="w-9 h-9 object-contain" />
          </div>
        )}
      </div>

      {/* NAVIGATION */}
      <nav className="flex-1 py-3 overflow-y-auto">
        {filteredSidebar.map((item, index) => {

          const isParentActive =
            item.children &&
            item.children.some((sub) => location.pathname.startsWith(sub.path));

          return (
            <div key={index}>

              {/* PARENT WITH CHILDREN */}
              {item.children ? (
                <button
                  onClick={() => setOpenMenu(openMenu === index ? null : index)}
                  className={`flex items-center justify-between w-full py-2.5 text-sm ${
                    isOpen ? "px-5" : "justify-center"
                  } ${
                    isParentActive
                      ? "bg-blue-600 text-white"
                      : "text-slate-300 hover:bg-slate-700"
                  }`}
                >
                  <div className="flex items-center gap-3">
                    {item.icon}
                    {isOpen && <span>{item.label}</span>}
                  </div>

                  {/* COUNT BADGE on parent — only when sidebar is open */}
                  {isOpen && <CountBadge countKey={item.countKey} />}
                </button>

              ) : (

                /* SINGLE NAV ITEM */
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `flex items-center ${
                      isOpen ? "gap-3 px-5" : "justify-center"
                    } py-2.5 text-sm ${
                      isActive
                        ? "bg-blue-600 text-white font-semibold"
                        : "text-slate-300 hover:bg-slate-700"
                    }`
                  }
                >
                  {item.icon}
                  {isOpen && (
                    <>
                      <span>{item.label}</span>
                      <CountBadge countKey={item.countKey} />
                    </>
                  )}

                  {/* Collapsed sidebar — show dot indicator if count > 0 */}
                  {!isOpen && item.countKey && counts[item.countKey] > 0 && (
                    <span className="absolute ml-6 mt-[-18px] w-2 h-2 rounded-full bg-red-500" />
                  )}
                </NavLink>

              )}

              {/* DROPDOWN */}
              {/* {item.children && openMenu === index && isOpen && (
                <div className="px-5 py-2">
                  <select
                    onChange={(e) => { if (e.target.value) window.location.href = e.target.value; }}
                    className="w-full h-7 px-1 text-xs bg-white border border-slate-400 text-black rounded-sm focus:outline-none cursor-pointer"
                    defaultValue=""
                  >
                    <option value="">Select {item.label}</option>
                    {item.children.map((sub, i) => (
                      <option key={i} value={sub.path}>{sub.label}</option>
                    ))}
                  </select>
                </div>
              )} */}

              {/* DROPDOWN */}
{item.children && openMenu === index && isOpen && (
  <div className="px-5 py-2">
    <select
      onChange={(e) => { if (e.target.value) window.location.href = e.target.value; }}
      className="w-full h-7 px-1 text-xs bg-white border border-slate-400 text-black rounded-sm focus:outline-none cursor-pointer"
      defaultValue=""
    >
      <option value="">Select {item.label}</option>
      {item.children.map((sub, i) => (
        <option key={i} value={sub.path}>
          {sub.label}
          {sub.countKey && counts[sub.countKey] > 0
            ? ` (${counts[sub.countKey]})`
            : ""}
        </option>
      ))}
    </select>
  </div>
)}

            </div>
          );
        })}
      </nav>

      {/* FOOTER */}
      <div className="px-5 py-4 border-t border-slate-700 text-xs text-slate-500">
        {isOpen && (
          <div className="flex items-center gap-2">
            <img src={ZentelexLogo} alt="Zentelex Logo" className="w-12 h-12 object-contain" />
            <span>Design and Developed by Zentelex Pvt Ltd</span>
          </div>
        )}
      </div>

    </aside>
  );
}